import React, {PureComponent} from 'react';
import {Route} from 'react-router';
import cx from 'classnames';
import CollectionCase from 'components/page/CollectionCase';
import styles from './styles.module.sass';

class Body extends PureComponent {
  render() {
    return (
      <div className={cx('Body', styles.component)}>
        <Route component={CollectionCase}/>
      </div>
    );
  }
}

export default Body;


// WEBPACK FOOTER //
// ./src/components/layout/Body/Body.jsx